/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_State_Not_FoundInputs */

const vi_vehicle_gps_state_not_found = /** @type {(inputs: Vehicle_Gps_State_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMEI của xe chưa tìm thấy trên VnetGPS. Kiểm tra lại IMEI hoặc tài khoản VnetGPS trên server.`)
};

/**

* @param {Vehicle_Gps_State_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_state_not_found = /** @type {((inputs?: Vehicle_Gps_State_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_State_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_state_not_found(inputs)
});